import React from 'react';

/**
 * "نشط" / "غير نشط" / "غير مشترك" on a subscription card.
 *
 * The design only draws the inactive state — a red-tinted pill with a red
 * hairline. The active one is its counterpart in green/280, the file's own
 * variable, because a card for a live subscription still has to say so and
 * leaving it unstyled would be the more invented choice.
 *
 * `none` is a package the reader does not hold. It is not a fault and not a
 * success, so it takes neither colour: the card's own grey ground and hairline,
 * lettered in the grey the card already uses for its secondary text.
 *
 * Ground and hairline are the tint and the edge; the lettering is the full
 * value. All three come from one group and are never split up.
 */
const TONES = {
    danger: 'tw-bg-v2-student-danger-tint tw-border-v2-student-danger-edge tw-text-v2-student-danger',
    ok: 'tw-bg-v2-student-ok/10 tw-border-v2-student-ok/40 tw-text-v2-student-ok',
    none: 'tw-bg-v2-neutral-50 tw-border-v2-neutral-200 tw-text-v2-student-aside',
};

const StatusPill = ({ tone = 'danger', children }) => (
    <span
        className={
            'tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap ' +
            'tw-rounded-full tw-border tw-border-solid tw-px-[17px] tw-py-[4px] ' +
            `tw-text-[13px] tw-font-bold tw-leading-[1.6] ${TONES[tone] ?? TONES.danger}`
        }
    >
        {children}
    </span>
);

export default StatusPill;
